export default __webpack_public_path__ + "static/media/sidebar-4.b7eb4d1b.jpg";